import styled, { css } from 'styled-components';
import { Fonts, Palette } from '../../../components/utils';

/** Shared size and shape for all booking list/detail status pills. */
export const bookingsStatusPillBase = css`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  min-width: 60px;
  box-sizing: border-box;
  font-family: ${Fonts.OPEN_SANS_FONT}, sans-serif;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  padding: 4px 12px;
  border-radius: 20px;
  border: 1px solid transparent;
  text-align: center;
`;

export const DEFAULT_BOOKINGS_STATUS_PILL_COLORS = {
  background: Palette.HAZY_BLUE,
  color: Palette.WHITE,
  border: Palette.HAZY_BLUE
};

/** Per-status pill colors: background, text, border. */
export const BOOKINGS_STATUS_PILL_COLORS = {
  Block: {
    background: Palette.DISABLED,
    color: Palette.CONTENT_TERTIARY,
    border: Palette.CONTENT_TERTIARY
  },
  Pending: {
    background: Palette.YELLOW_100,
    color: Palette.ORANGE_500,
    border: Palette.ORANGE_500
  },
  Reserved: {
    background: Palette.SURFACE_SUCCESS,
    color: Palette.GREEN_500,
    border: Palette.GREEN_500
  },
  Cancelled: {
    background: Palette.BACKGROUND_TAG_RED,
    color: Palette.CONTENT_NEGATIVE,
    border: Palette.CONTENT_NEGATIVE
  }
};

export const BookingsStatusPill = styled.span`
  ${bookingsStatusPillBase}
  background-color: ${({ $background }) => $background};
  color: ${({ $color }) => $color};
  border-color: ${({ $border }) => $border};
`;
